import { storeToRefs } from "pinia";
import { getStore } from "@/store/index";
import { v4 as uuidv4 } from 'uuid';

// 获取当前字段全局状态
export const useCsrCmpState = ({
    stateKey, dataConf, cmpName
}) => {
    const store = getStore();
    let moduleStateKey = null;
    // 当组件不在表单3.0中，而是作为子组件被引用时，不存在stateKey，需要重新生成state
    if (!stateKey) {
        moduleStateKey = `${cmpName}-${uuidv4()}`;
        store.addCsrState(moduleStateKey, {
            value: dataConf?.defaultValue,
            conf: {
                error: false,// 设置一个默认的值，解决数据改变，视图没发生变化的问题
                ...dataConf,
            },
            cmpName,
        });
    }
    // 在表单3.0中使用statekey，在子组件中使用moduleStateKey
    const usingStateKey = stateKey || moduleStateKey
    const state = storeToRefs(store).csrState.value[usingStateKey];
    return { store, state, usingStateKey };
}